
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/city/[cityName]",
      function () {
        return require("private-next-pages/web/city/[cityName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web/city/[cityName]"])
      });
    }
  